<template>
  <div class="transferHistory">
      <h2>
          {{$t('TransactionHistory')}}
      </h2>
      <Table :columns="columns" :data="transferData" :loading="loading" >
		  <template slot-scope="{ row }" slot="insTime">
			  <span>{{ row.insTime | formattest}}</span>
		  </template>
		  <template slot-scope="{ row }" slot="dwType">
			  <span>{{ row.dwType | dwTypeFilter(that) }}</span>
		  </template>
          <template slot-scope="{ row }" slot="type">
			  <span>{{ row.type | typeFilter(that) }}</span>
		  </template>
          <template slot-scope="{ row }" slot="status">
			  <span>{{ row.status | statusFilter(that) }}</span>
		  </template>
	  </Table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;">
                <Page :total="total" :current="pageIndex" :page-size="pageSize" @on-change="changePage" ></Page>
            </div>
        </div>
  </div>
</template>

<script>
// @ is an alias to /src
import {mapState} from 'vuex'
import { dateFormat } from '../../plugins/common.js'


export default {
  name: 'transferHistory',
  data(){
    return{
        loading:false,
		isReal: 1,
        columns: [
            {
                title: this.$t('transferTime'),
                slot: 'insTime'
            },
            {
                title: this.$t('transferType'),
				slot: 'dwType'
            },
            {
                title: this.$t('transferWay'),
				slot: 'type'
            },
            {
                title: this.$t('transferRef'),
				key: 'account'
            },
            {
                title: this.$t('transferYuan'),
				key: 'source'
            },
            {
                title: this.$t('transferAim'),
				key: 'target'
            },
            {
                title: this.$t('transferMoney'),
				key: 'amount'
            },
            {
                title: this.$t('transferStatus'),
				slot: 'status'
            },
            {
                title: this.$t('transferRemark'),
				key: 'remark'
            },
        ],
        transferData: [],
        pageIndex:1,
        pageSize:5,
        total:0,
        that:this,
    }
  },
    computed: {
        ...mapState(['lang','userInfo'])
    },
    
    filters: {
        formattest(val) {
            var crtTime = new Date(val);
            return dateFormat("YYYY-mm-dd HH:MM", crtTime)
        },
        dwTypeFilter(val,that) {
            switch (val) {
                case 1:
                    return that.$t('Withdraw')
                    break;
                case 0:
                    return that.$t('Deposit')
                    break;
                default:
                    break;
            }
        },
        typeFilter(val,that) {
            return that.$t('transfer')
        },
        statusFilter(val,that){
            switch (val) {
                case 1:
                    return that.$t('transferSuccess')
                    break;
                case 0:
                    return that.$t('transferPending')
                    break;
                case 2:
                    return that.$t('transferFail')
                    break;
                default:
                    break;
            }
        }
    },
    created(){
        this.getAccounts()
    },
    methods:{
        getAccounts(type){
			this.loading = true
            this.$axios.get('/api/MoneyStream/Index',{
				params:{
                    pageIndex:this.pageIndex,
                    pageSize:this.pageSize
				}
			})
            .then(async (res) => {
				let dt = res.data
				this.loading = false
                if(dt.status == 1){
                    this.transferData = dt.obj.data
                    this.total = dt.obj.totalCount
                    
                }else{
                    this.$Message.error(dt.msg)
                }
            })
            .catch((err) => {
				this.loading = false
			})
        },
        changePage(val){
            this.pageIndex = val
            this.getAccounts()
        }
    }
}
</script>
<style lang="less">
.transferHistory{
    width: 1440px;
    margin: 0 auto;
    height: 100%;
    position: relative;
    h2{
        margin-top: 20px;
        font-weight: normal;
        font-size: 18px;
        color: #332c2b;
        line-height: 50px;
        padding-bottom: 20px;
    }
    .account-btns{
        position: absolute;
        right: 0;
        top: 0;
    }
	.register-demo{
		display: inline-flex;
		align-items: center;
	}
    .ivu-table-tbody tr td:last-child .ivu-table-cell div{
        width: 50px;
        margin: 0 auto;
        position: relative;
        cursor: pointer;
        line-height: 60px;
    }
    .ivu-table-tbody tr td:last-child .ivu-table-cell div::after{
            content: "";
            position: absolute;
            right: -2px;
            top: 24px;
            border-top: 5px solid #8b8b8c;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
    }
    .tableSetting{
        display: none;
        position: absolute;
        top: 45px;
        right: -38px;
        z-index: 9999;
        box-shadow: 0px 8px 16px 0px rgba(0,0,0,.2);
        background: #ffffff;
        li{
            line-height: 60px;
            min-width: 120px;
        }
    }
    .ivu-table-tbody tr td:last-child .ivu-table-cell div:hover .tableSetting{
        display: block;
        // background: chartreuse;
    }
	.ivu-table-tip td{
		width: auto!important;
	}
}
</style>
